import gql from 'graphql-tag'

export const GET_LOGS = gql`
  query GetLogs {
    logs(orderBy: createdAt_DESC) {
      id
      action
      hero {
        id
        name
      }
      material {
        id
        name
      }
      user {
        id
        name
      }
      description
      valueInt
      valueString
      location
      userAgent
      createdAt
    }
  }
`
